import { render } from "./whatisGPU.vue?vue&type=template&id=f6c16f3a&scoped=true"
import script from "./whatisGPU.vue?vue&type=script&lang=js"
export * from "./whatisGPU.vue?vue&type=script&lang=js"

import "./whatisGPU.vue?vue&type=style&index=0&id=f6c16f3a&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c16f3a"]])

export default __exports__